import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

import { StepIndicator } from "@/modules/eventRegistration/features/EventRegistration/components/StepIndicator/StepIndicator";
import { ProductCheckoutProvider } from "./ProductCheckoutContext";
import { CustomerInfoStep } from "./CustomerInfoStep";
import { Skeleton } from "@/components/ui/skeleton";
import { useProductCheckoutPage } from "../../hooks/useProductCheckoutPage";
import ProductCheckoutShellAdapter from "../ProductCheckoutShellAdapter/ProductCheckoutShellAdapter";

// Confirmation now lives at /product-directory/orders/:uuid/confirmation
// (rendered by <ProductOrderConfirmation>) so it's bookmarkable, emailable,
// and survives a refresh. The wizard collapses to two in-flow steps.
const STEPS = [{ label: "Customer Info" }, { label: "Payment" }];

function CheckoutFlowContent() {
  const { items, loading, currentStep, handleStepClick } =
    useProductCheckoutPage();

  if (loading && items.length === 0) {
    return (
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8">
        <div className="grid grid-cols-2 gap-4">
          <Skeleton className="h-8 w-full" />
          <Skeleton className="h-8 w-full" />
        </div>
      </div>
    );
  }

  if (!loading && items.length === 0) {
    return (
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8 text-center">
        <p className="text-gray-500 dark:text-gray-400 mb-4">
          Your cart is empty
        </p>
        <Link
          className="text-gray-900 dark:text-white underline hover:no-underline"
          to="/product-directory"
        >
          Browse products
        </Link>
      </div>
    );
  }

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 py-8">
      <Helmet>
        <title>Checkout</title>
      </Helmet>

      <StepIndicator
        activeStep={currentStep}
        onStepClick={handleStepClick}
        steps={STEPS}
      />

      {currentStep === 0 && <CustomerInfoStep />}
      {currentStep === 1 && <ProductCheckoutShellAdapter />}
    </div>
  );
}

export default function ProductCheckoutPage() {
  return (
    <ProductCheckoutProvider>
      <CheckoutFlowContent />
    </ProductCheckoutProvider>
  );
}
